import styled from '@emotion/styled';
import { Progress } from 'semantic-ui-react';

export const UtilisationBar = ({ value }: { value: number }) => (
  <S.Progress label={`${value}%`} percent={value} size="tiny" color="blue" />
);

const S = {
  Progress: styled(Progress)`
    &.ui.progress .bar {
      min-width: 0 !important;
    }
  `,
};
